'use client'
import { PaginationSkeleton } from '@morpho-org/ui-v6/client'
import { Skeleton } from '@repo/ui'

// The header and a full page of rows: the vaults people visit have more than a page of history.
const VaultV2AllocationTransactionsLoading = () => {
  return (
    <div className="gap-xs flex flex-col">
      <Skeleton className="h-[259px] w-[100%] rounded-[20px]" />
      <PaginationSkeleton />
    </div>
  )
}

export default VaultV2AllocationTransactionsLoading
